import React, {useEffect, useState} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {makeStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogActions from '@material-ui/core/DialogActions';
import {ActionButton} from 'components/common';
import PMCSnackbar from "../../common/Snackbar";
import UserUpdate from "./UserUpdate";
import {CircularProgress} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    container: {
        '& .MuiDialog-paper': {
            maxHeight: 855,
            minHeight: '90%',
            maxWidth: 'unset',
            // boxShadow: theme.palette.shadow.main,
        },
        height: '100%',
    },
    actions: {
        padding: 0,
    },
    title: {
        height: 96,
        background: theme.palette.secondary.main,

        '& h2': {
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: 26,
            lineHeight: '30px',
            color: theme.palette.base.white,
        },
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        margin: 0,
        paddingBottom: theme.spacing(4),

    },
    button: {
        width: 180,
        height: 40,
        marginLeft: 20,
        marginRight: 20,
        fontSize: 14,
    },
    buttonNavigation: {
        display: 'flex',
        background: theme.palette.base.white,
        height: '55px',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        bottom: 0,
        width: '50%',
        justifyContent: 'flex-end',
    },
    buttonNavigationCancel: {
        display: 'flex',
        background: theme.palette.base.white,
        height: '55px',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        bottom: 0,
        width: '50%',
        justifyContent: 'left',
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
    },
}));


function User(props) {
    const {
        userUseCases,
        roles,
        rowClickHandel,
        headerClickHandel,
        headerChecked,
        handleClose,
        saveUser,
        userConfigModel,
        subjects,
        branches,
        parkings,
        codeList,
        snackbarOpen,
        setSnackbarOpen,
        error,
        setError,
        saving,
        setSaving
    } = props;


    const classes = useStyles();

    const {t} = useTranslation();

    const [updatedUser, setUpdatedUser] = useState();
    const [errorStep1, setErrorStep1] = useState('');
    const [localParkings, setLocalParkings] = useState();

    useEffect(() => {
        if (userConfigModel.user)
            setUpdatedUser(userConfigModel.user);
    }, [userConfigModel]);

    useEffect(()=>{
        if ( parkings && parkings.length>0 && !localParkings ) {
            setLocalParkings([...parkings]);
        }
    }, [parkings]);

    const isValid = (isNew) => {
        let ret = true;
        const error = {};
        if (!updatedUser.lastName || updatedUser.lastName.trim().length === 0) {
            error.lastName = 'required';
            ret = false;
        }
        if (!updatedUser.username || updatedUser.username.trim().length === 0) {
            error.username = 'required';
            ret = false;
        }
        if (!updatedUser.email || updatedUser.email.trim().length === 0) {
            error.email = 'required';
            ret = false;
        }
        if (!updatedUser.password && isNew) {
            error.password = 'required';
            ret = false;
        }
        if (!updatedUser.active) {
            error.active = 'required';
            ret = false;
        }

        if (!updatedUser.subjectId) {
            error.subjectId = 'required';
            ret = false;
        }
        if (!updatedUser.branchId) {
            error.branchId = 'required';
            ret = false;
        }
        if (!updatedUser.parkingIds) {
            error.parkingIds = 'required';
            ret = false;
        }

        console.log('error', error);
        setErrorStep1(error);

        return ret;
    }

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen(false);
    };

    const handleChange = (name) => (event) => {
        if (event && event.target) {
            setUpdatedUser({...updatedUser, [name]: event.target.value});
        } else {
            setUpdatedUser({...updatedUser, [name]: event});
        }
    }

    const handleChangeParking = (newValue) => {
        let tmp = [];
        newValue.map((item) => {
            tmp.push(item.parkingId);
        })

        setUpdatedUser({...updatedUser, parkings: newValue, parkingIds:tmp.join(',')});
    }

    const handleChangeReportingRole = (newValue) => {
        setUpdatedUser({...updatedUser, reportingRoles: newValue});
    }

    const handleChangeSipParking = (newValue) => {
        let tmp = [];
        newValue.map((item) => {
            tmp.push(item.parkingId);
        });

        setUpdatedUser({...updatedUser, sipParkings: newValue, sipParkingIds:tmp.join(',')})
    }

    return (
        <Dialog
            className={classes.container}
            open={userConfigModel.open}
            onClose={handleClose}
        >
            <DialogTitle className={classnames(classes.title)}>
                <span>
                    {t(userConfigModel.readOnly?'DETAIL_USER':(userConfigModel.isNew ? 'CREATE_USER' : 'UPDATE_USER'))}
                </span>
            </DialogTitle>

            <PMCSnackbar open={snackbarOpen} onClose={handleCloseSnackbar} severity={'error'} message={error}/>

            <DialogContent className={classes.content}>
                <div className={classes.container}>
                    <UserUpdate 
                        userUseCases={userUseCases}
                        roles={roles}
                        rowClickHandel={rowClickHandel}
                        headerClickHandel={headerClickHandel}
                        headerChecked={headerChecked}
                        handleChange={handleChange}
                        handleChangeParking={handleChangeParking}
                        handleChangeReportingRole={handleChangeReportingRole}
                        handleChangeSipParking={handleChangeSipParking}
                        updatedUser={updatedUser}
                        error={errorStep1}
                        readOnly={userConfigModel.readOnly}
                        setSnackbarError={setError}
                        setSnackbarOpen={setSnackbarOpen}
                        subjects={subjects}
                        branches={branches}
                        parkings={localParkings}
                        codeList={codeList}
                        isNew={userConfigModel.isNew}
                    />
                </div>
            </DialogContent>
            <DialogActions className={classes.actions}>
                <div className={classes.buttonNavigationCancel}>
                    <div className={classes.wrapper}>
                        {!userConfigModel.readOnly &&
                        <ActionButton
                            action="close"
                            handleClick={handleClose}
                            className={classes.button}
                        />
                        }
                    </div>

                </div>
                <div className={classes.buttonNavigation}>
                    <div className={classes.wrapper}>
                        {!userConfigModel.readOnly &&
                            <>
                                <ActionButton
                                    
                                    loading={saving}
                                    action="save" handleClick={() => {
                                        const ret = isValid(userConfigModel.isNew);
                                        if (ret) {
                                            saveUser(updatedUser);
                                            setSaving(true);
                                        }
                                    }}
                                    className={classes.button}
                                />
                                {saving && <CircularProgress size={24} className={classes.buttonProgress}/>}
                            </>
                        }
                        {userConfigModel.readOnly &&
                            <ActionButton
                                action="close"
                                handleClick={handleClose}
                                className={classes.button}
                            />
                        }                          
                    </div>
                </div>
            </DialogActions>
        </Dialog>

    );
}

User.propTypes = {};

const mapStateToProps = (store) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(User);


